import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import IframeResizer from "./components/IframeResizer";
import Home from "./pages/Home";
import Submit from "./pages/Submit";
import Archive from "./pages/Archive";
import SectionTopics from "./pages/SectionTopics";
import About from "./pages/About";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import GetAccess from "./pages/GetAccess";
import Admin from "./pages/Admin";
import AdminTopicBank from "./pages/AdminTopicBank";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <IframeResizer />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/section/:code" element={<SectionTopics />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/get-access" element={<GetAccess />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/topics" element={<AdminTopicBank />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
